import { render } from "./ImageWithLoader.vue?vue&type=template&id=f868af0a&scoped=true&ts=true"
import script from "./ImageWithLoader.vue?vue&type=script&lang=ts"
export * from "./ImageWithLoader.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=f868af0a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f868af0a"]])

export default __exports__